import { useEffect, useState } from 'react';

// Use this for the button's action
const APP_STORE_URL = 'https://apps.apple.com/us/app/facebook/id284882215'; 
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.sama.sama_tech&pcampaignid=web_share'; 

// These are no longer needed for the simple store redirect
// const APP_CUSTOM_SCHEME = 'yourappscheme://'; 
// const ANDROID_PACKAGE_NAME = 'com.sama.sama_tech'; 
// const REDIRECTION_DELAY = 500; 

const isMobile = {
    Android: () => navigator.userAgent.match(/Android/i),
    iOS: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
    any: () => isMobile.Android() || isMobile.iOS(),
};

const MobileRedirector = () => {
    // Renamed state to control the visibility of the "Go to Store" popup
    const [showStorePrompt, setShowStorePrompt] = useState(false);
    const [os, setOs] = useState(null);

    useEffect(() => {
        const isOnMobile = isMobile.any();

        if (isOnMobile) {
            let detectedOs = null;
            if (isMobile.iOS()) {
                detectedOs = 'iOS';
            } else if (isMobile.Android()) {
                detectedOs = 'Android';
            }
            
            setOs(detectedOs);
            // Show the prompt instead of immediately redirecting
            setShowStorePrompt(true);
        }
    }, []);

    const handleDownloadClick = () => {
        // Redirect to the correct store URL based on detected OS
        const storeUrl = os === 'iOS' ? APP_STORE_URL : PLAY_STORE_URL;
        window.location.href = storeUrl;
        // Hide the prompt after clicking
        setShowStorePrompt(false);
    };

    if (!showStorePrompt) {
        return null;
    }
    
    // Determine button text based on OS
    const downloadButtonText = os === 'iOS' ? 'Download on the App Store' : 'Get it on Google Play';
    
    // The redirector UI is now the store prompt
    return (
        <div style={{
            position: 'fixed', 
            top: 0, 
            left: 0, 
            width: '100%', 
            height: '100%', 
            backgroundColor: 'rgba(0,0,0,0.8)', 
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div style={{ 
                padding: '30px', 
                textAlign: 'center', 
                backgroundColor: '#fff', 
                borderRadius: '10px',
                maxWidth: '80%',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}>
                <p style={{ color: '#333', fontSize: '16px' }}>
                    For a better experience, we recommend using our mobile application.
                </p>
                <button 
                    onClick={handleDownloadClick}
                    style={{
                        padding: '10px 20px',
                        margin: '10px',
                        backgroundColor: '#4285F4', // Google Play/App Store color style
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >
                    {downloadButtonText}
                </button>
                <button 
                    onClick={() => setShowStorePrompt(false)}
                    style={{
                        padding: '10px 20px',
                        margin: '10px',
                        backgroundColor: '#ccc',
                        color: '#333',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Continue to web version
                </button>
            </div>
        </div>
    );
};

export default MobileRedirector;